module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "monitor"
  }, [_c('v-header', {
    attrs: {
      "name": _vm.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [(_vm.banner.length != 0) ? _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-wrap",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.banner), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item,
        "alt": ""
      }
    })])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  })], 1), _vm._v(" "), _vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "produce-flow"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("产品生产流程：")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/product/flow-chart.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a2ab2a1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/index.vue
// module id = 1930
// module chunks = 2